var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.939,
    height: 21.939,
    viewBox: "0 0 21.939 21.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir_refresh-circle",
    transform: "translate(-1.05 -1.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M12.02,22.039A10.02,10.02,0,1,0,2,12.02,10.02,10.02,0,0,0,12.02,22.039Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#59a52c",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M16.6,9.672A5.078,5.078,0,0,0,12,7a4.834,4.834,0,0,0-5,4.008",
    transform: "translate(0.01 0.01)",
    fill: "none",
    stroke: "#59a52c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M14.508,9.726h1.91a.6.6,0,0,0,.6-.6V7.5m-9.6,6.179a5.037,5.037,0,0,0,4.6,3.34,5.251,5.251,0,0,0,5-5.01",
    transform: "translate(0.011 0.011)",
    fill: "none",
    stroke: "#59a52c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M9.511,13.622H7.6a.6.6,0,0,0-.6.6v2.182",
    transform: "translate(0.01 0.023)",
    fill: "none",
    stroke: "#59a52c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIcon);
export default __webpack_public_path__ + "static/media/total-icon.b06a48dd57beb23e1124426c6632fcdd.svg";
export { ForwardRef as ReactComponent };